import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetSaleRequestSurchargeAssignmentMutationResponse, GetSaleRequestSurchargeAssignmentPathParams } from "../../types/GetSaleRequestSurchargeAssignment";

/**
     * @summary Данные поручения об оплате по доплате
     * @link /api/salerequests/:requestId/surcharges/:surchargeId/assignment
     */
export async function getSaleRequestSurchargeAssignment (requestId: GetSaleRequestSurchargeAssignmentPathParams["requestId"], surchargeId: GetSaleRequestSurchargeAssignmentPathParams["surchargeId"], options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetSaleRequestSurchargeAssignmentMutationResponse>["data"]> {
    const { data: resData } = await client<GetSaleRequestSurchargeAssignmentMutationResponse>({
        method: "post",
        url: `/api/salerequests/${requestId}/surcharges/${surchargeId}/assignment`,
        ...options
    });
    
    return resData;
};